// Module
var code = "<div flex=\"none\" ng-class=\"{'bg_yellow_color': badgeVm.isPending, 'bg_green_color': badgeVm.isSigned}\" class=\"document-signature-badge\"> <span ng-if=\"badgeVm.isPending\"><i class=\"fa fa-warning\"></i> Needs Signature</span> <span ng-if=\"badgeVm.isSigned\"><i class=\"fa fa-check\"></i> Signed</span> </div> ";
// Exports
var _module_exports = code;;
var path = 'app/common/directive/documentSignatureBadge/template/documentSignatureBadge.directive.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;